<template>
  <GeneralDashboardLayout>
      <template v-slot:header>
          <div class="header-template">
              <BackButton :to="{ name: 'landing-page.index', params: { event_id: $route.params.event_id } }" />
      
              <h1>Landing Page Settings </h1>
                <div>
                    <button class="btn btn-outline-light" @click="submitForm">Save Changes</button>
                    &nbsp;  <button class="btn btn-outline-light" @click="cancelEdit">Cancel</button>
                </div>



          </div>
      </template>
      <template v-slot:content>
          <div id="assets_content">
              <div class="fluid-container demo agenda_content">
                  <div class="row no_lm">
                      <div class="col-lg-12">
                          <div class="kt-portlet">
                                  <div class="kt-portlet__body">
                                     <tabs :options="{ useUrlFragment: false, defaultTabHash: 'theme-contents' }">
                                          <tab name="Header Section" :selected="true">
                                              <ThemeContentsTab />
                                          </tab>
                                          <tab name="Mid Section" >
                                            <FlagsTab/>
                                          </tab>
                                          <tab name="Footer Section">
                                            <BannersTab/>
                                          </tab>
                                          <tab name="Text Section">
                                            <TextTab/>
                                          </tab>

                                          <!--<tab name="Theme Color">
                                            <ColorTab/>
                                          </tab>
                                          -->
                                          
                                        </tabs>
                                    </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <FlashMessage group="landing_page_index" />

      </template>
   
  </GeneralDashboardLayout>
</template>


<script>
import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
import {mapActions, mapGetters} from "vuex";
import BannersTab       from "@/components/cruds/LandingPageSettings/Tabs/FooterTab";
import FlagsTab         from "@/components/cruds/LandingPageSettings/Tabs/MidTab";
import TextTab         from "@/components/cruds/LandingPageSettings/Tabs/TextTab";
import ColorTab         from "@/components/cruds/LandingPageSettings/Tabs/ColorTab";

import ThemeContentsTab from "@/components/cruds/LandingPageSettings/Tabs/ThemeContentsTab";
import { gettingErrorMessage } from "@/services/GetValidationMessage";
import BackButton       from "@/components/Commons/BackButton";

export default {
  name: 'EventHallsEdit',
  components: {
      TextTab,
      BannersTab,
      ThemeContentsTab,
      FlagsTab,
      BackButton,
      GeneralDashboardLayout
      //ColorTab
  },
  data() {
      return {
          event_theme: null,
      };
  },
  computed: {
      ...mapGetters("LandingPageSettingsSingle", [
          "item",
          "loading"
         
      ])
  },
  async created() {
    await this.fetchData(this.$route.params);
    this.setEvent(this.$route.params.event_id);
  },
  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.landing_page_index;
  },
 
  watch: {
      
  },
  methods: {
      ...mapActions("LandingPageSettingsSingle", [
          "fetchData",
          "updateData",
          "resetState",
          "setEvent"
      ]),
      cancelEdit() {
        this.$router.back()
      },
      async submitForm() {
        try {
          const response = await this.updateData();
          console.log("✅ API Response:", response);

        
          this.resetState();

          this.$router.push({
            name: 'landing-page.index',
            params: { event_id: this.$route.params.event_id }
          });

        } catch (error) {
          console.error("🔥 Error caught in submitForm:", error);

          const html = gettingErrorMessage(error);

          this.$flashMessage.show({
            group: 'landing_page_index',
            type: 'error',
            title: 'Failed',
            html
          });
        }
    }


  }
};
</script>


<style>
.eventhall_flags .col-lg-4 {
  display: inline-block !important;
  margin-bottom: 50px;
  float: left;
  height: 100px;
}

label {
  display: inline;
}
.image-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.image-item {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.image-item img {
  width: 100px;
  height: 60px;
  object-fit: cover;
  border-radius: 5px;
}

.image-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.image-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.remove-btn {
  padding: 5px 10px;
  font-size: 14px;
  color: #fff;
  background-color: #e74c3c;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.remove-btn:hover {
  background-color: #c0392b;
}

    .event_detail_wrapper {
        border-bottom: 0px solid #ccc;
        padding: 10px 0px;
    
        .event_ls_label {
            font-weight: bold;
        }
    }
    
    .setting_wrapper {
        float: right;
    
        a {
            color: #201e1eba;
            padding: 9px;
            margin-left: 5px;
            background: #c0cdd345;
            border-radius: 4px;
            border: 1px solid #80808054;
        }
    }
    
    .toggle label {
        color: #000 !important;
    }
    
    .drop-files {
        margin-top: 10px;
    }
    
    .newspeaker {
        margin-top: 20px;
    }
    
    .newspeaker button {
        width: 100%;
    }
    
    .add_spk_btn {
        background-color: #0088CC;
        color: #fff;
    }
    
    .mini_txt {
        font-size: 0.8em;
        color: #585252;
        font-style: italic;
        margin-bottom: 10px;
    }
    
    .v-dialog>.v-overlay__content>.v-card {
        border-radius: 15px;
        padding-top: 20px;
    }
    
    .tabs-left .nav-tabs>li .active {
        border-left-color: #0088CC;
    }
    
    .orangebtn {
        background-color: orange;
    }
    
    .wrapp {
        display: block;
        text-align: center;
        margin-bottom: 10px;
    }
    .flash-content {
        z-index: 10;
    }
    
    .dark{
      --popper-theme-text-color: #ffffff;
      --popper-theme-padding: 15px;
      --popper-theme-background-color: #333333;
      --popper-theme-border-radius: 6px;
      --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
    }
    
    .tooltip_img img{    
        position: absolute;
        top: -53px;
        left: 50px;
        width: 300px;
        height: auto;
    }
</style>